export default __webpack_public_path__ + "static/media/scancard.54015817.jpg";